import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';

const SubmissionSuccessDialog = ({
  open,
  onOpenChange,
  title,
  description,
  nextStep,
  buttonText = 'Done',
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md overflow-hidden border-0 p-0 shadow-2xl sm:rounded-lg">
      <div className="bg-red-700 px-6 py-5 text-white">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white/15">
          <CheckCircle2 className="h-7 w-7" aria-hidden="true" />
        </div>
      </div>

      <div className="px-6 pb-6 pt-5">
        <DialogHeader className="space-y-3 text-left">
          <DialogTitle className="text-2xl font-bold leading-tight text-gray-900">
            {title}
          </DialogTitle>
          <DialogDescription className="text-base leading-7 text-gray-600">
            {description}
          </DialogDescription>
        </DialogHeader>

        {nextStep && (
          <div className="mt-5 rounded-lg border border-red-100 bg-red-50 px-4 py-3 text-sm leading-6 text-gray-700">
            {nextStep}
          </div>
        )}

        <DialogFooter className="mt-6">
          <DialogClose asChild>
            <Button className="w-full bg-red-700 text-white hover:bg-red-800 sm:w-auto">
              {buttonText}
            </Button>
          </DialogClose>
        </DialogFooter>
      </div>
    </DialogContent>
  </Dialog>
);

export default SubmissionSuccessDialog;
